import { createSlice } from "@reduxjs/toolkit";

const deviceInfoSlice = createSlice({
    name: "deviceInfo",
    initialState: {
        data: {
            isMobile: false,
            iPAddress: "",
            deviceInfo: "",
        },
    },
    reducers: {
        setDeviceInfo: (state, action) => {
            state.data = action.payload
        }
    },
});

export const { setDeviceInfo } = deviceInfoSlice.actions;
export default deviceInfoSlice.reducer;